import { render, staticRenderFns } from "./service-i18n.vue?vue&type=template&id=3c9db5ec&scoped=true&"
import script from "./service-i18n.vue?vue&type=script&lang=js&"
export * from "./service-i18n.vue?vue&type=script&lang=js&"
import style0 from "./service-i18n.vue?vue&type=style&index=0&id=3c9db5ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9db5ec",
  null
  
)

export default component.exports